import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import axios from "axios"
import Sidebar from "../components/Sidebar"
import DashboardHeader from "../components/DashboardHeader"

const BASE_URL = process.env.REACT_APP_API_BASE_URL

const ProfilePage = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [profileData, setProfileData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [profilePhoto, setProfilePhoto] = useState(null);

  const accessToken = useSelector((state) => state.auth.access)
  const user = useSelector((state) => state.auth.user);

  // Fetch profile photo separately
    useEffect(() => {
      const fetchUserProfile = async () => {
        try {
          const token = localStorage.getItem("access");
          const res = await axios.get(`${BASE_URL}/users/profile/`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const p = res.data.profile_photo;
          if (p) {
            setProfilePhoto(
              p.startsWith("http") ? p : `${BASE_URL}${p}`
            );
          } else {
            setProfilePhoto(null);
          }
        } catch (e) {
          setProfilePhoto(null);
        }
      };
      fetchUserProfile();
    }, []);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/users/profile/`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        setProfileData(res.data)
        setLoading(false)
      } catch (err) {
        setError("Failed to load profile")
        setLoading(false)
      }
    }

    if (accessToken) fetchProfile()
  }, [accessToken])

  const userData = {
    name: profileData ? `${profileData.first_name} ${profileData.last_name}` : "User",
    initials: profileData
      ? (profileData.first_name[0] + profileData.last_name[0]).toUpperCase()
      : "U",
    notificationCount: 4,
  }

  return (
    <div className="dashboard-container">
      <div className="d-flex">
        <Sidebar collapsed={sidebarCollapsed} toggleSidebar={() => setSidebarCollapsed((prev) => !prev)}/>
        <div className="main-content flex-grow-1">
          <DashboardHeader user={user} profilePhoto={profilePhoto} onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)} />
          <div className="dashboard-content p-4">
            <h2 className="dashboard-title mb-4">My Profile</h2>

            {loading ? (
              <p>Loading profile...</p>
            ) : error ? (
              <p className="text-danger">{error}</p>
            ) : (
              <div className="profile-content">
                <div className="profile-card">
                  <div className="profile-field">
                    <div className="field-label">Registration Date</div>
                    <div className="field-value">
                      {new Date(profileData.date_joined).toLocaleString()}
                    </div>
                  </div>

                  <div className="profile-field">
                    <div className="field-label">First Name</div>
                    <div className="field-value">{profileData.first_name}</div>
                  </div>

                  <div className="profile-field">
                    <div className="field-label">Last Name</div>
                    <div className="field-value">{profileData.last_name}</div>
                  </div>

                  <div className="profile-field">
                    <div className="field-label">Username</div>
                    <div className="field-value">{profileData.username}</div>
                  </div>

                  <div className="profile-field">
                    <div className="field-label">Email</div>
                    <div className="field-value">{profileData.email}</div>
                  </div>

                  <div className="profile-field">
                    <div className="field-label">Phone Number</div>
                    <div className="field-value">{profileData.contact || "-"}</div>
                  </div>

                  <div className="profile-field">
                    <div className="field-label">Skill/Occupation</div>
                    <div className="field-value">{profileData.occupation || "-"}</div>
                  </div>

                  <div className="profile-field">
                    <div className="field-label">Biography</div>
                    <div className="field-value">{profileData.bio || "-"}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfilePage
